import {ADD_VERANSTALTUNG_ALERT_SHOW, ADD_VERANSTALTUNG_ALERT_CLOSE, SHOW_HEADER_ALERT,
	DIMISS_HEADER_ALERT } from './actions'
import { FETCH_VERANSTALTUNG_REQUEST, FETCH_VERANSTALTUNG_REQUEST_FAILURE, FETCH_PUNKTEMELDUNGEN_REQUEST_FAILURE, FETCH_PUNKTEMELDUNGEN_REQUEST } from '../veranstaltungen/actions'
import { messageOn401VNR } from '../../components/HeaderAlert'
import { TEILNEHMER_MELDEN_FAILED } from '../punkteMeldung/teilnehmermeldenActionCreator'

const initialState = {
	addVeranstaltungAlertIsOpen : false,
	addVeranstaltungAlertMessage : "Some error ...",
	headerAlertIsOpen : false,
	headerAlertMessage : "test error ...",
	headerAlertColor : "danger"
}

export const alertsReducer = (state = initialState, action) => {
	switch(action.type){

		case ADD_VERANSTALTUNG_ALERT_SHOW:
				return {...state, addVeranstaltungAlertIsOpen : true, addVeranstaltungAlertMessage : action.message}

		case ADD_VERANSTALTUNG_ALERT_CLOSE:
		case FETCH_VERANSTALTUNG_REQUEST:
			return {...state, addVeranstaltungAlertIsOpen : false, headerAlertIsOpen : false}

		case FETCH_PUNKTEMELDUNGEN_REQUEST:
			return {...state, headerAlertIsOpen : false}

		case FETCH_VERANSTALTUNG_REQUEST_FAILURE:
		case FETCH_PUNKTEMELDUNGEN_REQUEST_FAILURE:
		case TEILNEHMER_MELDEN_FAILED:
				if(action.payload === 401)
				return {...state, headerAlertIsOpen : state.addVeranstaltungAlertIsOpen?false:true, headerAlertMessage : messageOn401VNR, headerAlertColor : "danger"}
			else return state

		case 	DIMISS_HEADER_ALERT:
			return {...state, headerAlertIsOpen : false}

		case SHOW_HEADER_ALERT:
				return {...state, headerAlertIsOpen : true, headerAlertMessage : action.payload.message,
					headerAlertColor : action.payload.alertColor}

		default:
		return state
	}
}
